<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="content-box" style="padding: 0.5rem">
          <div class="element-box" style="padding: 1rem; margin-bottom: 0rem">
            <h5 class="form-header">
              Transacción de Cobro &nbsp;
              <span v-if="current.numero != null"># {{ current.numero }}</span>
              &nbsp;
              <div
                class="badge"
                :class="{
                  'badge-success': current.estado == 'A',
                  'badge-warning': current.estado == 'B',
                  'badge-danger': current.estado == '9',
                }"
              >
                <i class="os-icon os-icon-ui-09"></i>
                <span v-if="current.estado_str">{{ current.estado_str }}</span>
                <span v-if="!current.estado_str">En Proceso</span>
              </div>
              <div class="st-meta float-right">
                <div class="element-actions">
                  <div class="form-header">
                    <button
                      class="btn btn-outline-dark"
                      type="button"
                      @click="imprimir(current)"
                      :disabled="current.estado == 'A'"
                    >
                      <i class="fa fa-print"></i>
                      Imprimir
                    </button>
                    &nbsp;
                    <div class="btn-group">
                      <button
                        aria-expanded="false"
                        aria-haspopup="true"
                        class="btn btn-secondary dropdown-toggle"
                        data-toggle="dropdown"
                        type="button"
                      >
                        <i class="fa fa-cogs"></i>
                        Acciones
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <button
                          class="dropdown-item"
                          :class="{ disabled: !(current.estado == 'B') }"
                          @click="abrir"
                          :disabled="!(current.estado == 'B')"
                          href="#"
                        >
                          <i class="fa fa-unlock"></i>
                          Abrir Operación
                        </button>
                        <button
                          class="dropdown-item"
                          @click="finalizar"
                          :disabled="!(current.estado == 'A')"
                          href="#"
                        >
                          <i class="fa fa-lock"></i>
                          Finalizar Cobro
                        </button>
                        <button
                          class="dropdown-item"
                          @click="anular"
                          :disabled="!(current.estado != '9')"
                          href="#"
                        >
                          <i class="fa fa-archive"></i>
                          Anular Operación
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </h5>
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 0.5rem" class="content-box">
      <div class="row">
        <div class="col-12">
          <div class="element-box" style="margin-bottom: 0rem">
            <small
              v-if="current.errors && current.errors.detail"
              class="form-text text-danger"
              >{{ current.errors.detail }}</small
            >
            <div class="row">
              <div class="col-sm-3">
                <div class="form-group">
                  <label for>Tienda</label>
                  <div class="input-group">
                    <input
                      disabled
                      v-model="current.tienda.nombre"
                      class="form-control"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group">
                  <label for>Caja</label>
                  <div class="input-group">
                    <input
                      disabled
                      v-model="current.caja.caja"
                      class="form-control"
                      placeholder="Caja"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group">
                  <label>Vendedor</label>
                  <input
                    v-if="current.vendedor"
                    :disabled="true"
                    class="form-control"
                    v-model="current.vendedor.name"
                    type="text"
                  />
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group">
                  <label for>Fecha</label>
                  <div class="input-group">
                    <input
                      disabled
                      v-model="current.fecha"
                      class="form-control"
                      placeholder="Fecha"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <div class="col-sm-3" v-if="current.cliente">
                <div class="form-group">
                  <label>Nit del Cliente</label>
                  <div class="input-group">
                    <input
                      id="nit"
                      disabled
                      ref="nit"
                      v-if="current.cliente"
                      v-model="current.cliente.nit"
                      class="form-control"
                      placeholder="Nit"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <div class="col-sm-9" v-if="current.cliente">
                <div class="form-group">
                  <label for>Nombre del Cliente</label>
                  <div class="input-group">
                    <input
                      id="nombre"
                      disabled
                      ref="nombre"
                      v-model="current.cliente_nombre"
                      class="form-control"
                      placeholder="Nombre"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="text-center">
                  <h6 class="text-center text-dark">
                    Total de Saldo de Cliente
                  </h6>
                  <div v-if="current.saldo_pendiente">
                    <h4 class="text-danger">
                      {{ formatDecimalCurrency(current.saldo_pendiente) }}
                    </h4>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="text-center">
                  <h6 class="text-center text-dark">Total Facturas a Pagar</h6>
                  <div>
                    <h4 class="text-success">
                      {{ formatDecimalCurrency(current.total_facturas) }}
                    </h4>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div>
                  <h6 class="text-center text-dark">Total Pagado Agregado</h6>
                  <div>
                    <h4 class="text-center text-success">
                      {{ formatDecimalCurrency(current.total_pagado) }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div style="padding: 0.5rem" class="content-box">
          <div class="element-box">
            <h6>Detalle de Pagos Realizados</h6>
            <div class="table-responsive" v-if="current.id != null">
              <!-------------------- START - Basic Table -------------------->
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Forma de Pago</th>
                    <th class="text-right">Total</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="detalle in current.cxccobrod_set"
                    v-bind:key="detalle.id"
                  >
                    <td>{{ detalle.forma_pago_obj.nombre }}</td>
                    <td class="text-right">{{ detalle.total }}</td>
                    <td class="text-right">
                      <button
                        v-if="current.estado == 'A'"
                        class="btn btn-sm btn-danger"
                        type="button"
                        @click="deleteDetalle(detalle)"
                      >
                        <i class="fa fa-trash"></i>
                        Eliminar
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-------------------- END - Basic Table -------------------->
              <div class="btn-group">
                <router-link
                  :to="{ name: 'cxc-cobros', params: {} }"
                  class="btn btn-sm btn-outline-info"
                  >Regresar</router-link
                >
                &nbsp;&nbsp;&nbsp;
                <NuevoPagoModalComponent
                  @refreshData="refreshCurrent"
                  :current="current"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div style="padding: 0.5rem" class="content-box">
          <div class="element-box">
            <h6>Facturas a Aplicar</h6>
            <div class="form-desc" style="margin-bottom: 0px">
              Facturas a las que se le aplicara el pago
            </div>
            <div class="table-responsive" v-if="current.id != null">
              <!-------------------- START - Basic Table -------------------->
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Factura</th>
                    <th class="text-right">Total</th>
                    <th class="text-right">Saldo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="detalle in current.cxccobrocargoaplicar_set"
                    v-bind:key="detalle.id"
                  >
                    <td>
                      {{ detalle.cargo_e_obj.cargo_serie }} -
                      {{ detalle.cargo_e_obj.numero }}
                    </td>
                    <td class="text-right">
                      {{ formatDecimalCurrency(detalle.valor_total) }}
                    </td>
                    <td class="text-right">
                      {{ formatDecimalCurrency(detalle.saldo_actual_cargo) }}
                    </td>
                    <td class="text-right">
                      <button
                        v-if="current.estado == 'A'"
                        class="btn btn-sm btn-danger"
                        type="button"
                        @click="eliminarFactura(detalle)"
                      >
                        <i class="fa fa-trash"></i>
                        Eliminar
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td class="text-right">Total</td>
                    <td class="text-right">Q {{ current.total_cargos }}</td>
                    <td class="text-right">Q {{ current.saldo_total_cargos }}</td>
                  </tr>
                </tfoot>
              </table>
              <!-------------------- END - Basic Table -------------------->
              <div class="btn-group">
                <AgregarFacturaAplCobroModalComponent
                  @refreshData="refreshCurrent"
                  :current="current"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div style="padding: 0.5rem" class="content-box">
          <div class="element-box">
            <h6>Notas de crédito a descontar</h6>
            <div class="form-desc" style="margin-bottom: 0px">
              Notas de crédito en facturas agregadas que se descontará del pago
            </div>
            <div class="table-responsive" v-if="current.id != null">
              <!-------------------- START - Basic Table -------------------->
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Nota de crédito</th>
                    <th class="text-right">Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="devolucion in current.notas_aplicar.devoluciones"
                    v-bind:key="devolucion.id"
                  >
                    <td>
                      {{ devolucion.numero}}
                    </td>
                    <td class="text-right">
                      Q {{ devolucion.total }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td class="text-right">Total a descontar:</td>
                    <td class="text-right">
                      Q {{ current.notas_aplicar.total }}
                    </td>
                  </tr>
                </tfoot>
              </table>
              <!-------------------- END - Basic Table -------------------->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import NuevoPagoModalComponent from "@/components/cxc/cobros/NuevoPagoModalComponent";
import AgregarFacturaAplCobroModalComponent from "@/components/cxc/cobros/AgregarFacturaAplCobroModalComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    NuevoPagoModalComponent,
    AgregarFacturaAplCobroModalComponent,
  },
  data() {
    return {
      currentPago: {},
      form_pago: null,
      forma_pago: {},
      current: {
        id: null,
        caja: {
          caja: "",
        },
        cliente: {
          nit: "",
          nombre: "",
        },
        estado_str: "",
        tienda: "",
        fecha: " ",
        estado: "A",
        errors: [],
        saldo_pendiente: 0,
        total_pagado: 0,
        total_facturas: 0,
      },
    };
  },
  computed: {},
  mounted() {
    let self = this;
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
  },
  methods: {
    formatDecimalCurrency(valor) {
      if (valor == 0) {
        return "Q 0.00";
      }
      return (
        "Q " +
        valor.toLocaleString("es-GT", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        })
      );
    },
    refreshUnidadMedida() {
      let self = this;
      if (self.currentDetalle.producto == null) {
        self.currentDetalle.producto = {
          lista_precios: [],
        };
        return;
      }
      if (self.currentDetalle.producto.sku == null) {
        self.currentDetalle.producto["lista_precios"] = [];
        return;
      }
      DynamicService.getByIdParams(
        "cat",
        "productos",
        self.currentDetalle.producto.sku,
        {
          tienda: self.current.tienda.codigo,
        }
      ).then((response) => {
        self.currentDetalle.producto = response.data;
        if (self.currentDetalle.producto.lista_precios.length > 0) {
          self.currentDetalle.precio_actual =
            self.currentDetalle.producto.lista_precios[0];
        } else {
          self.currentDetalle.precio_actual = null;
        }
      });
    },
    refreshCurrent() {
      let self = this;
      DynamicService.getById("cxc", "cobros", this.$route.params.id).then(
        (response) => {
          self.current = response.data;
        }
      );
    },
    showModalAddDetail() {
      let self = this;
      DynamicService.fetch("cat", "forma-pago").then((response) => {
        self.forma_pago = response.data.results;
        $("#modalAddDetailReqCompra").modal();
      });
    },
    deleteDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Cobro de Cuenta",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          DynamicService.postAction(
            "cxc",
            "cobros",
            self.current.id,
            "eliminar_pago",
            {
              id: detalle.id,
            }
          )
            .then((response) => {
              Notifications.alert.success(
                "Pago",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
            });
        }
      );
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Cobro de Cuenta",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          DynamicService.postAction("cxc", "cobros", self.current.id, "abrir")
            .then((response) => {
              Notifications.alert.success(
                "Cobro de cuenta",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Abrir Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Cobro de Cuenta",
        "Desea cerrar la transacción?",
        "Si Cerrar",
        function () {
          DynamicService.postAction("cxc", "cobros", self.current.id, "cerrar")
            .then((response) => {
              Notifications.alert.success(
                "Cobro de cuenta",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    finalizar() {
      let self = this;
      Notifications.alert.confirm(
        "Cobro de cuenta",
        "Desea Finalizar la transacción?",
        "Si Finalizar",
        function () {
          DynamicService.postAction(
            "cxc",
            "cobros",
            self.current.id,
            "finalizar"
          )
            .then((response) => {
              Notifications.alert.success(
                "Cobro de Cuenta",
                "Se ha Finalizado la transacción."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Finalizar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Cobro de cuenta",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          DynamicService.postAction("cxc", "cobros", self.current.id, "anular")
            .then((response) => {
              Notifications.alert.success(
                "Cobeo de cuenta",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Anular Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    eliminarFactura(factura) {
      let self = this;
      DynamicService.postAction(
        "cxc",
        "cobros",
        self.current.id,
        "eliminar_factura",
        {
          id: factura.id,
        }
      ).then((response) => {
        {
          Notifications.alert.success(
            "Eliminacion de Factura",
            "¡se ha realizado exitosamente!"
          );
          self.refreshCurrent();
        }
      });
    },
    imprimir(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      self.id = current.id.replace(/-/g, "");
      window.open(
        `${baseApiUrl}/cat/reporte/?&report_name=cxc/cobros/ReciboCaja_MediaCarta.jrxml&Id=${self.id}`
      );
    },
  },
};
</script>
